import React from "react";
import PropTypes from "prop-types";

import Announcement from "../../../../static/images/Announcement.svg";

const Disclaimer = ({children, ...props}) => {
  return (
    <div className={`disclaimer ${props.containerClass ?? ""}`}>
      <span className="disclaimer-image">
        <img src={Announcement} />
      </span>
      <span className="disclaimer-text">
        {children}
      </span>
    </div>
  );
}

Disclaimer.propTypes = {
    containerClass: PropTypes.string
}

export default Disclaimer;